/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Stack, Text } from "@fluentui/react";
import { FluentProvider, teamsLightTheme } from "@fluentui/react-components";
import { PageError, BusyIndicator } from "../../../";
import { Signin } from "../../../../../app/pages";
import Loader from "../../Loader";
import PopUpModal from "../../../../../app/components/main/Services/PopUpPanel";
import ErrorBoundary from "../../../../../errorHandling/errorBoundry";
import { V2_HeaderTabNav } from "../../../../../app/components/header/V2component_Header/V2_HeaderTab";
import { V2_CatalogPage } from "../../../../../app/components/CatalogPage/V2component_catalog/V2_CatalogPage";
import FeedbackTabComponent from "../../../../../app/components/feedback/FeedbackTabComponent";
import { V2_Main } from "../../../../../app/components/main/V2component_main/V2_main";
import { TicketDetailPage } from "../../../../../app/components/main/ticketdetails/TicketDetailsRender";
import ChatDocumentWrapper from "../../../../../app/components/ChatDocument/ChatDocumentWrapper";
import { V2_HeaderTabNavNewUI } from "../../../../../app/components/header/NewUI_component_Header/NewUI_HeaderTab";
import { NewUITicketDetailPage } from "../../../../../app/components/main/ticketdetails/NewUI_TicketDetailsRender";
import { CardContainer } from "../../NewUI/tile/CardContainer";
import { RecommendedHelp } from "../../NewUI/tile/RecommendedHelp";
import { appConfig } from "../../../../../app/App.config";
import {
  NOT_AI_Authorised,
  NOT_AI_AUTHORISED_TWO,
} from "../../../../../app/utils/constants";
import { messages } from "../../Shell.messages";
import { TileContextProvider } from "../../../../../app/context/TileContext";

/**
 * Extracted from V2_Shell.tsx — renderRoutes (Zero Logic Change)
 * All parent-scope variables are passed as props.
 */
export interface ShellRoutesProps {
  // Auth & startup
  isUserLoggedIn: boolean;
  isStartupError: boolean;
  startupError: any;
  shouldShowSignin: () => boolean;
  shouldShowBusyIndicator: () => boolean;
  shouldShowExtensionBusyIndicator: () => boolean;
  shouldShowCopilot: () => boolean;
  shouldShowNotAiAuthorized: () => boolean;
  intl: any;
  // User state
  currentUserDbId: number;
  currentUserData: any;
  currentUser: any;
  isProfileLoading: boolean;
  setProfileLoading: (val: boolean) => void;
  isPresetModal: boolean;
  handleConfirmPreset: () => void;
  hideConfirmModel: () => void;
  // Tab & navigation
  isWwicCopilotOpen: boolean;
  selectedActiveTab: string;
  setActiveTabKeyinShell: (key: string) => void;
  showErrorModal: any;
  setShowErrorModal: (...args: any[]) => void;
  // Iris & bot
  setIris_Utterance: (val: any) => void;
  resetShellIrisContext: () => void;
  setTile_Name: (val: any) => void;
  set_irisAppName: (val: any) => void;
  setFormDataToIris: (val: any) => void;
  setshowBotinShell: (val: any) => void;
  setChatBotClicked: (val: any) => void;
  setIrisBotIconClicked: (val: any) => void;
  handleIrisLoading: (...args: any[]) => void;
  messageHistory: any;
  irisPayload: any;
  closeCopilot: () => void;
  // Catalog & services
  setAddServiceId: (val: any) => void;
  catalogServicesResponse: any;
  setServicesAdded: (val: any) => void;
  isLoading: boolean;
  setSearchTerm: (val: any) => void;
  setSingleServiceAdded: (val: any) => void;
  hasFetchedData: any;
  addServiceId: any;
  setServiceDeleted: (val: any) => void;
  // Main workspace
  isPageLoad: boolean;
  userDataChanged: any;
  finalTileObject: any;
  isCanceledPreset: boolean;
  reccomendedData: any;
  recommendationLoaded: boolean;
  setRecommendationLoaded: (val: boolean) => void;
  setSubSegment: (val: any) => void;
  setSegment: (val: any) => void;
  userWelcomeUpdated: any;
  refreshHeaderTabCount: any;
  setRefreshHeaderTabCount: (val: any) => void;
  isAiUser: boolean;
  isAiServicesEnabled: boolean;
  isWwicAiEnabled: boolean;
  // Tickets
  setActiveTicketCount: (val: any) => void;
  loadTicketData: (...args: any[]) => void;
  // Context & extensions
  context: any;
  extensionsRegistrationClient: any;
  shellProps: any;
}

export const ShellRoutes: React.FC<ShellRoutesProps> = (p) => {
  const Window = window as any;

  if (Window.hasStartupDataInprogress === true) {
    return null;
  }

  if (!p.isUserLoggedIn && appConfig.loginOnStartup) return null;
  if (p.shouldShowSignin()) {
    return <Signin isUserLoggedIn={p.isUserLoggedIn} />;
  }
  if (p.isStartupError) return <PageError error={p.startupError} />;
  if (p.shouldShowBusyIndicator()) {
    return <BusyIndicator message={p.intl.formatMessage(messages.loadingUserProfile)} />;
  }
  if (p.shouldShowExtensionBusyIndicator()) {
    return <BusyIndicator message={p.intl.formatMessage(messages.loadingExtensionRegistraton)} />;
  }

  if (p.currentUserDbId > 0) {
    return (
      <Stack className="main-container-shell">
        <Loader
          isLoading={p.isProfileLoading}
          setProfileLoading={p.setProfileLoading}
        />
        <PopUpModal
          isVisible={p.isPresetModal}
          onConfirm={p.handleConfirmPreset}
          onCancel={p.hideConfirmModel}
          onHide={p.hideConfirmModel}
          dialogTitle={"Reset Preference Confirmation"}
          dialogSubText={
            "You are identified as Non-Americas User, would you like to reset your My Help Workspace to Americas services?"
          }
          buttonsCount={2}
          buttonTextOne={"Yes"}
          buttonTextTwo={"No"}
        />

        {!p.isWwicCopilotOpen && window.location.pathname !== '/wwicai' && (
          <V2_HeaderTabNav
          setActiveTabKey={p.setActiveTabKeyinShell}
          activeTabKey={p.selectedActiveTab}
          showErrorModal={p.showErrorModal}
          setShowErrorModal={p.setShowErrorModal}
          currentUserData={p.currentUserData}
          catalogComnponent={
            <ErrorBoundary componentName="Services">
              <V2_CatalogPage
                setActiveTabKey={p.setActiveTabKeyinShell}
                setIrisContext={p.setIris_Utterance}
                resetCatalogIrisContext={p.resetShellIrisContext}
                userId={p.currentUserDbId}
                setAddServiceId={p.setAddServiceId}
                catalogServicesResponse={p.catalogServicesResponse}
                setServicesAdded={p.setServicesAdded}
                isLoading={p.isLoading}
                setSearchTerm={p.setSearchTerm}
                setSingleServiceAdded={p.setSingleServiceAdded}
                handleIrisLoading={p.handleIrisLoading}
                currentUserData={p.currentUserData}
                hasFetchedData={p.hasFetchedData}
              />
            </ErrorBoundary>
          }
          feedbackTabComponent={
            <ErrorBoundary componentName="Feedback">
              <FeedbackTabComponent context={p.context} />
            </ErrorBoundary>
          }
          myHelpWorkspaceComponent={
            <>
              <TileContextProvider
                value={{
                  setActiveTabKey: p.setActiveTabKeyinShell,
                  userId: p.currentUserDbId,
                  userDataChanged: p.userDataChanged,
                  currentUserData: p.currentUserData,
                  setIrisUtterance: p.setIris_Utterance,
                  setTileName: p.setTile_Name,
                  setIrisAppName: p.set_irisAppName,
                  isUserLoggedIn: p.isUserLoggedIn,
                  addServiceId: p.addServiceId,
                  setAddServiceId: p.setAddServiceId,
                  setServiceDeleted: p.setServiceDeleted,
                  setFormDataToIris: p.setFormDataToIris,
                  setShowBot: p.setshowBotinShell,
                  setChatBotClicked: p.setChatBotClicked,
                  finalTileObject: p.finalTileObject,
                  setProfileLoading: p.setProfileLoading,
                  isCanceledPreset: p.isCanceledPreset,
                  showErrorModal: p.showErrorModal,
                  setShowErrorModal: p.setShowErrorModal,
                  reccomendedData: p.reccomendedData,
                  recommendationLoaded: p.recommendationLoaded,
                  setRecommendationLoaded: p.setRecommendationLoaded,
                  setSubSegment: p.setSubSegment,
                  setSegment: p.setSegment,
                  userWelcomeUpdated: p.userWelcomeUpdated,
                  setRefreshHeaderTabCount: p.setRefreshHeaderTabCount,
                  refreshHeaderTabCount: p.refreshHeaderTabCount,
                  enableWwicCopilot: p.isAiUser && p.isAiServicesEnabled && p.isWwicAiEnabled,
                  setIrisBotIconClicked: p.setIrisBotIconClicked,
                }}
              >
                <V2_Main
                  isPageLoad={p.isPageLoad}
                  setActiveTabKey={p.setActiveTabKeyinShell}
                  userId={p.currentUserDbId}
                  isUserLoggedIn={p.isUserLoggedIn}
                  setRefreshHeaderTabCount={p.setRefreshHeaderTabCount}
                  refreshHeaderTabCount={p.refreshHeaderTabCount}
                />
              </TileContextProvider>
            </>
          }
          refreshHeaderTabCount={p.refreshHeaderTabCount}
          ticketsComponent={
            <>
              <TicketDetailPage
                activeTabKey={p.selectedActiveTab}
                setActiveTabKey={p.setActiveTabKeyinShell}
                userId={p.currentUserDbId}
                isUserLoggedIn={p.isUserLoggedIn}
                setIsTicketDetailVisible={false}
                status={"All"}
                setActiveTicketCount={p.setActiveTicketCount}
                loadTicketData={p.loadTicketData}
              />
            </>
          }></V2_HeaderTabNav>)}

        {p.shouldShowCopilot() && (
          <>
            <FluentProvider theme={teamsLightTheme}>
              <ChatDocumentWrapper
                setFormDataToIris={p.setFormDataToIris}
                setShowBot={p.setshowBotinShell}
                setChatBotClicked={p.setChatBotClicked}
                setIrisUtterance={p.setIris_Utterance}
                setIrisAppName={p.set_irisAppName}
                setTileName={p.setTile_Name}
                setMessageData={p.messageHistory}
                setIrisPayload={p.irisPayload}
                closeCopilot={p.closeCopilot}
                userEmail={p.currentUser.email}
              />
            </FluentProvider>
          </>
        )}

        {p.shouldShowNotAiAuthorized() && (
          <Stack verticalAlign="center" styles={{ root: { alignItems: "left", marginTop: "20%", marginLeft: "10%" } }}>
            <Text styles={{ root: { fontSize: "large", fontWeight: "bold", textAlign: "left" } }}>
              {NOT_AI_Authorised}
            </Text>
            <Text styles={{ root: { fontSize: "large", fontWeight: "bold", textAlign: "left" } }}>
              {NOT_AI_AUTHORISED_TWO}
            </Text>
          </Stack>
        )}

        {/* <>HeaderTabNav</> */}
      </Stack>
    );
  }

  return p.shellProps?.onRenderRoutes(
    p.extensionsRegistrationClient.getExtensionsPages()
  );
};

/**
 * Extracted from V2_Shell.tsx — renderRoutes_V2_Demo (Zero Logic Change)
 */
export interface ShellRoutesV2DemoProps {
  isUserLoggedIn: boolean;
  isStartupError: boolean;
  startupError: any;
  currentUserDbId: number;
  currentUserData: any;
  isProfileLoading: boolean;
  setProfileLoading: (val: boolean) => void;
  selectedActiveTab: string;
  setActiveTabKeyinShell: (key: string) => void;
  showErrorModal: any;
  setShowErrorModal: (...args: any[]) => void;
  setIris_Utterance: (val: any) => void;
  setTile_Name: (val: any) => void;
  set_irisAppName: (val: any) => void;
  setshowBotinShell: (val: any) => void;
  setChatBotClicked: (val: any) => void;
  context: any;
  loadedVisibility: boolean;
  userProfileLoadingStatus: boolean;
  extensionsLoadingStatus: boolean;
  intl: any;
  extensionsRegistrationClient: any;
  shellProps: any;
}

export const ShellRoutesV2Demo: React.FC<ShellRoutesV2DemoProps> = (p) => {
  const Window = window as any;

  if (Window.hasStartupDataInprogress === true) {
    return null;
  }

  if (!p.isUserLoggedIn) {
    if (appConfig.loginOnStartup) return null;
    if (p.context && !p.loadedVisibility)
      return <Signin isUserLoggedIn={p.isUserLoggedIn} />;
  }

  if (p.currentUserDbId > 0) {
    return (
      <Stack className="main-container-shell">
        <Loader
          isLoading={p.isProfileLoading}
          setProfileLoading={p.setProfileLoading}
        />

        <V2_HeaderTabNavNewUI
          setActiveTabKey={p.setActiveTabKeyinShell}
          activeTabKey={p.selectedActiveTab}
          showErrorModal={p.showErrorModal}
          setShowErrorModal={p.setShowErrorModal}
          currentUserData={p.currentUserData}
          catalogComnponent={
            <ErrorBoundary componentName="Services">
              <div />
            </ErrorBoundary>
          }
          myHelpWorkspaceComponent={
            <>
              <NewUITicketDetailPage
                setActiveTabKey={"0"}
                userId={"1"}
                isUserLoggedIn={true}
                setIsTicketDetailVisible={true}
                status={true}
              />
              <CardContainer
                setActiveTabKey={p.setActiveTabKeyinShell}
                setShowBot={p.setshowBotinShell}
                setChatBotClicked={p.setChatBotClicked}
                setIrisUtterance={p.setIris_Utterance}
                setTileName={p.setTile_Name}
                setIrisAppName={p.set_irisAppName}
                currentUserData={p.currentUserData}
              />
              <RecommendedHelp />
              {/* <V2_Main
                isPageLoad={p.isPageLoad}
                setActiveTabKey={p.setActiveTabKeyinShell}
                userId={p.currentUserDbId}
                userDataChanged={p.userDataChanged}
                currentUserData={p.currentUserData}
                setIrisUtterance={p.setIris_Utterance}
                setTileName={p.setTile_Name}
                setIrisAppName={p.set_irisAppName}
                isUserLoggedIn={p.isUserLoggedIn}
                addServiceId={p.addServiceId}
                setAddServiceId={p.setAddServiceId}
                setServiceDeleted={p.setServiceDeleted}
                setFormDataToIris={p.setFormDataToIris}
                setShowBot={p.setshowBotinShell}
                setChatBotClicked={p.setChatBotClicked}
                finalTileObject={p.finalTileObject}
                setProfileLoading={p.setProfileLoading}
                isCanceledPreset={p.isCanceledPreset}
                showErrorModal={p.showErrorModal}
                setShowErrorModal={p.setShowErrorModal}
                reccomendedData={p.reccomendedData}
                recommendationLoaded={p.recommendationLoaded}
                setRecommendationLoaded={p.setRecommendationLoaded}
                setSubSegment={p.setSubSegment}
                setSegment={p.setSegment}
                userWelcomeUpdated={p.userWelcomeUpdated}
                enableWwicCopilot={p.isAiUser && p.isAiServicesEnabled && p.isWwicAiEnabled}
              /> */}
            </>
          }
        />

      </Stack>
    );
  }

  if (p.isStartupError) {
    return <PageError error={p.startupError} />;
  }
  if (appConfig.enableUserSettingsApi && p.userProfileLoadingStatus) {
    return (
      <BusyIndicator
        message={p.intl.formatMessage(messages.loadingUserProfile)}
      />
    );
  }
  if (appConfig.registrationConfig.active) {
    if (p.extensionsLoadingStatus) {
      return (
        <BusyIndicator
          message={p.intl.formatMessage(messages.loadingExtensionRegistraton)}
        />
      );
    }
  }
  return p.shellProps?.onRenderRoutes(
    p.extensionsRegistrationClient.getExtensionsPages()
  );
};
